import { Component, Inject, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {ApiService} from '../shared/api.service';
import {Utils} from '../utils';

@Pipe({name: 'techFilter'})
export class TechFilterPipe implements PipeTransform {
    transform(list, text): string {
        if( !text ) {
            return list;
        }
        text = text.toLocaleLowerCase();
        
        return list.filter(item => {
            return item.options.some(option => option.name.toLocaleLowerCase().includes(text));
        });
    }
}

@Component({
    selector: 'edit-techniques',
    templateUrl: 'edit-techniques.component.html'
})
export class EditTechniquesComponent implements OnDestroy {
    canEdit = false
    loading = false;
    lockChecked = false;
    techEditor = '';
    techError = '';
    saved = false;
    heartbeatSubscription;
    techniques = [];
    newTechName = '';
    newTechError = '';
    newTechSaving = false;
    newTechSaved = false;
    techniquePageSearch = this.utils.rand();
    techniquePageTechName = this.utils.rand();
    techniquePageOptionName = this.utils.rand();
    techniquePageNewOptionName = this.utils.rand();
    techniquePageNewTechName = this.utils.rand();
    searchText = '';

    constructor(private api: ApiService, private dialog: MatDialog, public utils: Utils) {
        const user = this.api.getProp('user');
        if( user.role == 'editor' || user.role == 'administrator' ) {
            this.canEdit = true;
        }
        const techniques = JSON.parse(JSON.stringify( this.api.getProp('techniques') ));
        for (const key in techniques) {
            this.techniques.push({ label: key, options: techniques[key] });
        }
        
        this.checkLock(true);
        this.heartbeatSubscription = this.api.heartbeat.subscribe(() => {
            this.checkLock(false);
        });
    }
    optionNameChanged(tech, parent) {
        const apiTech = this.api.getProp('techniques');
        const apiParentObj = apiTech[parent];
        for(var i = 0; i < apiParentObj.length; i++) {
            const apiObj = apiParentObj[i];
            if( apiObj.value == tech.value && apiObj.name !== tech.name) {
                return true;
            }
        }
        return false;
    }
    updateOptionName(tech, option, parent) {
        this.resetErrors();
        if( !this.optionNameChanged(option, parent) ) {
            return;
        }
        tech.loading = true;
        this.api.doAction('post', 'techniques', {
            action: 'update_technique',
            parent: parent,
            value: option.value,
            name: option.name
        }).subscribe(
            data => {
                const apiTech = this.api.getProp('techniques');
                const apiOptions = apiTech[parent];
                for(var i = 0; i < apiOptions.length; i++) {
                    const apiOption = apiOptions[i];
                    if( apiOption.value == option.value ) {
                        apiOption.name = option.name;
                    }
                }
                this.triggerSaveMessage(tech);
            },
            err => {
                tech.error = err.error.message;
                throw err;
            }
        ).add(() => {
            tech.loading = false;
        });
    }
    maybeRemoveOption(tech, option) {
        this.resetErrors();
        tech.saved = false;
        let dialogRef = this.dialog.open(RemoveTechniqueDialog, {
            data: option,
        });
        dialogRef.afterClosed().subscribe(data => {
            if( data === true ) {
                this.removeTechOption(tech, option);
            }
        });
    }
    removeTechOption(tech, option) {
        this.resetErrors();
        tech.loading = true;
        this.api.doAction('post', 'techniques', {
            action: 'delete_technique',
            parent: tech.label,
            value: option.value
        }).subscribe(
            data => {
                if( data.locked ) {
                    tech.error = 'Error deleting term. ' + data.techniqueEditor + ' is currently editing';
                    this.techEditor = data.techniqueEditor;
                    return;
                }
                const apiTech = this.api.getProp('techniques');
                const apiTechOptions = apiTech[tech.label];
                let i = apiTechOptions.length;
                while(i--) {
                    if( apiTechOptions[i].value == option.value ) {
                        apiTechOptions.splice(i, 1);
                    }
                }
                const options = tech.options;
                let j = options.length;
                while(j--) {
                    if( options[j].value == option.value ) {
                        options.splice(j, 1);
                    }
                }
                this.triggerSaveMessage(tech);
            },
            err => {
                tech.error = 'Error deleting term';
                throw err;
            }
        ).add(() => {
            tech.loading = false;
        });
    }
    hasTerm(tech) {
        const options = tech.options;
        const name = tech.newOptionName.toLocaleLowerCase();
        for(var i = 0; i < options.length; i++) {
            if( options[i].name.toLocaleLowerCase() == name ) {
                return true;
            }
        }
        return false;
    }
    addOption(tech) {
        this.resetErrors();
        tech.newOptionName = tech.newOptionName.trim();
        if( !tech.newOptionName ) {
            return;
        }
        if( this.hasTerm(tech) ) {
            tech.error = 'Term already exists';
            return;
        }
        tech.loading = true;
        const parent = tech.label;
        this.api.doAction('post', 'techniques', {
            action: 'add_technique',
            parent: parent,
            name: tech.newOptionName
        }).subscribe(
            data => {
                if( data.locked ) {
                    tech.error = 'Error saving new term. ' + data.techniqueEditor + ' is currently editing';
                    this.techEditor = data.techniqueEditor;
                    return;
                }
                this.api['techniques'][parent].push(JSON.parse(JSON.stringify(data)));
                tech.options.push(data);
                tech.search += ' ' + tech.newOptionName.toLocaleLowerCase();
                tech.newOptionName = '';
                this.triggerSaveMessage(tech);
            },
            err => {
                tech.error = err.error.message;
                throw err;
            }
        ).add(() => {
            tech.loading = false;
        });
    }
    triggerSaveMessage(obj) {
        obj.saved = true;
        setTimeout(() => {
            obj.saved = false;
        }, 3000);
    }
    maybeRemoveTech(tech) {
        this.resetErrors();
        tech.saved = false;
        tech.deleting = true;
        tech.loading = false;
        let dialogRef = this.dialog.open(RemoveTechniqueDialog, {
            data: tech,
        });
        dialogRef.afterClosed().subscribe(data => {
            if( data === true ) {
                this.removeTech(tech);
            } else {
                this.resetErrors();
                tech.deleting = false;
            }
        });
    }
    valueChanged(tech) {
        const apiTech = this.api.getProp('techniques');
        if( apiTech[tech.slug].name !== tech.name.trim() ) {
            return true;
        }
        return false;
    }
    updateTechName(tech) {
        this.resetErrors();
        if( !this.valueChanged(tech) ) {
            return;
        }
        tech.loading = true;
        this.api.doAction('post', 'techniques', {
            action: 'update_technique',
            technique: tech
        }).subscribe(
            data => {
                if( data.locked ) {
                    tech.error = 'Error updating technique name. ' + data.techniqueEditor + ' is currently editing';
                    this.techEditor = data.techniqueEditor;
                    return;
                }
                const apiTech = this.api.getProp('techniques');
                apiTech[tech.slug].name = tech.name;
                this.triggerSaveMessage(tech);
            },
            err => {
                tech.error = 'Error updating technique';
                throw err;
            }
        ).add(() => {
            tech.loading = false;
        });
    }
    removeTech(removedTech) {
        this.resetErrors();
        removedTech.loading = true;
        removedTech.deleting = true;
        const slug = removedTech.slug;
        this.api.doAction('post', 'techniques', {
            action: 'delete_technique',
            slug: slug
        }).subscribe(
            data => {
                if( data.locked ) {
                    removedTech.error = 'Error deleting technique. ' + data.techniqueEditor + ' is currently editing';
                    this.techEditor = data.techniqueEditor;
                    return;
                }
                delete this.api['techniques'][slug];
                const tech = this.techniques;
                let i = tech.length;
                while(i--) {
                    if( tech[i].slug == slug ) {
                        tech.splice(i, 1);
                        this.triggerSaveMessage(this);
                    }
                }
            },
            err => {
                removedTech.error = 'Error deleting technique';
                throw err;
            }
        ).add(() => {
            removedTech.loading = false;
            removedTech.deleting = false;
        });
    }
    hasTech() {
        const techniques = this.techniques;
        const name = this.newTechName.toLocaleLowerCase();
        for(var i = 0; i < techniques.length; i++) {
            const techName = techniques[i].name.toLocaleLowerCase();
            if( techName == name ) {
                return true;
            }
        }
        return false;
    }
    resetErrors() {
        this.newTechError = '';
        this.techError = '';
        const tech = this.techniques;
        for(var i = 0; i < tech.length; i++) {
            tech[i].error = '';
        }
    }
    addTech() {
        this.newTechName = this.newTechName.trim();
        if( this.newTechName == '' ) {
            return;
        }
        if( this.hasTech() ) {
            this.newTechError = 'Technique already exists';
            return;
        }
        this.newTechSaving = true;
        this.api.doAction('post', 'techniques', {
            action: 'add_technique',
            name: this.newTechName
        }).subscribe(
            data => {
                if( data.locked ) {
                    this.newTechError = 'Error saving new technique. ' + data.techniqueEditor + ' is currently editing';
                    this.techEditor = data.techniqueEditor;
                    return;
                }
                this.api['techniques'][data.slug] = JSON.parse(JSON.stringify(data));
                this.techniques.push(data);
                this.newTechName = '';
                this.triggerSaveMessage(data);
                this.triggerSaveMessage(this);
            },
            err => {
                this.newTechError = err.error.message;
                throw err;
            }
        ).add(() => {
            this.newTechSaving = false;
        });
    }
    takeover() {
        this.resetErrors();
        this.loading = true;
        this.api.doAction('post', 'techniques', {
            action: 'set_lock',
            lockAction: 'update'
        }).subscribe(
            data => {
                this.canEdit = true;
                this.techEditor = '';
            },
            err => {
                this.techError = err.error.message;
            }
        ).add(() => {
            this.loading = false;
        });
    }
    deleteLock() {
        this.techError = '';
        this.loading = true;
        this.api.doAction('post', 'techniques', {
            action: 'set_lock',
            lockAction: 'delete'
        }).subscribe().add(() => {
            this.canEdit = false;
            this.loading = false;
        });
    }
    checkLock(takeover) {
        this.api.doAction('post', 'techniques', {
            action: 'check_lock'
        }).subscribe(
            data => {
                if( data.locked ) {
                    this.techEditor = data.techniqueEditor;
                }
                if( !data.locked && takeover ) {
                    this.takeover();
                }
                if( !this.lockChecked ) {
                    this.canEdit = !data.locked;
                }
                this.lockChecked = true;
            },
            err => {
                this.techError = err.error.message;
            }
        ).add(() => {
            this.loading = false;
        });
    }
    resetOptionInput(tech, optionInput) {
        this.resetErrors();
        if( tech.newOptionName ) {
            return;
        }
        optionInput.open = false;
    }
    openOptionInput(newOption) {
        newOption.open = true;
        setTimeout(() => {
            const input = newOption.querySelector('.new-option');
            if( input ) {
                input.focus();
            }
        }, 50);
    }
    ngOnDestroy() {
        this.deleteLock();
        if( this.heartbeatSubscription ) {
            this.heartbeatSubscription.unsubscribe();
        }
    }
    objectKeys(obj: object) {
        return Object.keys(obj);
    }
}
@Component({
    selector: 'remove-technique-dialog',
    template: `
        <h2 mat-dialog-title>Are you sure?</h2>
        <mat-dialog-content fxLayout="column" fxLayoutGap="10px">
            <p>Are you sure you want to delete '{{data.name}}'?</p>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button type="button" class="button" mat-dialog-close>Cancel</button>
            <button type="button" class="button" [mat-dialog-close]="true">Delete</button>
        </mat-dialog-actions>`,
})
export class RemoveTechniqueDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
}